import { render, staticRenderFns } from "./SubmissionsEntry.vue?vue&type=template&id=068f6f76&scoped=true&"
import script from "./SubmissionsEntry.vue?vue&type=script&lang=js&"
export * from "./SubmissionsEntry.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionsEntry.vue?vue&type=style&index=0&id=068f6f76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068f6f76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('068f6f76')) {
      api.createRecord('068f6f76', component.options)
    } else {
      api.reload('068f6f76', component.options)
    }
    module.hot.accept("./SubmissionsEntry.vue?vue&type=template&id=068f6f76&scoped=true&", function () {
      api.rerender('068f6f76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/SubmissionsEntry.vue"
export default component.exports